import { connect } from 'react-redux';

// Selectors
import {
  getAreas,
  getSelectedArea,
  getPollutants,
  getSelectedPollutant,
  getMembers,
  getSelectedMember
} from '../../selectors';

// Actions
import { setArea, setPollutant, setMember, setViewport } from '../../actions';

// Components
import TopBar from './component';

const mapStateToProps = state => ({
  areas: getAreas(state),
  selectedArea: getSelectedArea(state),
  pollutants: getPollutants(state),
  selectedPollutant: getSelectedPollutant(state),
  members: getMembers(state),
  selectedMember: getSelectedMember(state),
});

const mapDispatchToProps = dispatch => ({
  setArea: (area, resetDefault) => dispatch(setArea(area, resetDefault)),
  setPollutant: pollutant => dispatch(setPollutant(pollutant)),
  setMember: member => dispatch(setMember(member)),
  setViewport: viewport => dispatch(setViewport(viewport))
});

export default connect(mapStateToProps, mapDispatchToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/components/forecast-demo/components/top-bar/index.js